import React from 'react';
import { connect } from 'react-redux';
import "../../scss/global.scss";
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import Preloader from '../../components/Preloader';
import Main from '../../components/Main';
import Meta from '../../components/Meta';
import Navigation from '../../components/Navigation';
import NavigationList from '../../components/NavigationList';
import Section from '../../components/Section';
import { linkResolver, navResolver } from '../../components/helper';
import * as loaderActions from '../../actions/loader';
import * as uiActions from '../../actions/ui';

class CaseContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionsToLoad: props.data.caseJson.data.body.length,
      sectionsLoaded: 0,
    };
    this.setScrollPosition = debounce(this.setScrollPosition.bind(this), 100);
    this.onSectionLoad = this.onSectionLoad.bind(this);
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      this.setScrollPosition();
      window.addEventListener('scroll', this.setScrollPosition, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setScrollPosition);
    this.props.setScrollPosition({x: 0, y: 0});
    this.setState({
      sectionsLoaded: 0,
      sectionsToLoad: 0,
    });
  }

  setScrollPosition(e) {
    let scrollPosition;
    if (typeof window !== `undefined`) {
      scrollPosition = Object.assign({}, {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop,
      });
    }
    this.props.setScrollPosition(scrollPosition);
  }

  onSectionLoad() {
    this.setState(prevState => ({
      sectionsLoaded: prevState.sectionsLoaded + 1,
    }));
  }

  render() {
    const { url, meta_image, meta_title, data } = this.props.data.caseJson;
    const { body, background_image, image, title, home_link, navigation } = data;
    const homelink = linkResolver(home_link.type, home_link.uid);
    const navitems = navResolver(navigation.type, navigation.uid);
    return [
      <Meta
        key="meta"
        url={url}
        metaTitle={meta_title}
        metaImage={meta_image}
        {...this.props.data.site.siteMetadata} />,
      <Navigation key="nav" nav back={homelink} />,
      <NavigationList key="navitems" items={navitems} />,
      <Preloader key="preloader" percentage={Math.round((this.state.sectionsLoaded / this.state.sectionsToLoad) * 100)} />,
      <Main key="main">
        {body.map((x, i) => {
          if (i === 0) {
            return <Section key={x.primary.id || `section_${i}`} title={title} index={i} onSectionLoad={this.onSectionLoad} {...x}  />;
          }
          return <Section key={x.primary.id || `section_${i}`} index={i} onSectionLoad={this.onSectionLoad} {...x} />;
        })}
      </Main>
    ];
  }
}

const mapStateToProps = (state) => {
  return { }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setScrollPosition: (scrollPosition) => {
     dispatch(uiActions.setScrollPosition(scrollPosition))
   },
  }
}

const Case = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CaseContainer);

Case.defaultProps = {

};

Case.propTypes = {

};

export default Case;

export const query = graphql`
  query CasePageQuery($slug: String!) {
    caseJson(fields: { slug: { eq: $slug } }) {
      data {
        title {
          type
          text
        }
        navigation {
          type
          uid
        }
        home_link {
          type
          uid
        }
        url
      }
      ...Sections
      ...Items
      ...CaseMeta
    }
    site {
      ...SiteMeta
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/case/index.jsx